/**
 * Axis typography and chrome aligned with legacy Recharts graphView defaults.
 */

const AXIS_FONT_FAMILY =
  'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

/** Axis title: mobile 14 / desktop 18, bold, black (legacy graphView). */
export function plotlyAxisTitleFont(isMobile) {
  return {
    family: AXIS_FONT_FAMILY,
    size: isMobile ? 14 : 18,
    color: "#000000",
    weight: "bold",
  };
}

/**
 * Tick labels: default mobile 10 / desktop 12 bold black.
 * Legacy exception: Average Relative Weight vs Date uses 12 / 14.
 */
export function plotlyAxisTickFont(isMobile, variant = "default") {
  const size =
    variant === "dateAvgWr" ? (isMobile ? 12 : 14) : isMobile ? 10 : 12;
  return {
    family: AXIS_FONT_FAMILY,
    size,
    color: "#000000",
  };
}

/** Legacy axis line: black, 2px. */
export function plotlyAxisLineProps() {
  return {
    showline: true,
    linewidth: 2,
    linecolor: "#000000",
    zerolinecolor: "rgba(0,0,0,0.25)",
    zerolinewidth: 1,
  };
}

/** Grid: subtle dark lines (readable without full legacy black grid). */
export function plotlyGridProps() {
  return {
    showgrid: true,
    gridcolor: "rgba(0,0,0,0.12)",
    gridwidth: 1,
  };
}

/**
 * @param {string} text
 * @param {boolean} isMobile
 * @param {"default"|"dateAvgWr"} tickVariant
 */
export function plotlyAxisTitle(text, isMobile, tickVariant = "default") {
  return {
    text,
    font: plotlyAxisTitleFont(isMobile),
    standoff: isMobile ? 10 : 16,
  };
}

/** Common axis bundle: tick font, grid, line. */
export function plotlyAxisBase(isMobile, tickVariant = "default") {
  return {
    tickfont: plotlyAxisTickFont(isMobile, tickVariant),
    ...plotlyGridProps(),
    ...plotlyAxisLineProps(),
  };
}

/** X-axis for categorical bins (no vertical grid lines). */
export function plotlyAxisBaseCategoricalX(isMobile, tickVariant = "default") {
  return {
    ...plotlyAxisBase(isMobile, tickVariant),
    showgrid: false,
  };
}
